module.exports = __webpack_public_path__ + "static/media/Slowpoke_gaussian2.406617c1.png";